import { Injectable } from '@angular/core';
import { map, Subject } from 'rxjs';
import { SocketService } from '@services/webFeeder/socket.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { MessagePosition } from '@model/webFeeder/custody.model';
import { MessageParameterNegotiation } from '@model/webFeeder/message-parameter-negotiation.model';
import { MessageWebFeeder } from '@model/webFeeder/message-web-feeder.model';
import { Constants } from '@utils/constants';
import { Observable , of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PositionService {

  private serviceSubject = new Subject<MessageEvent>();
  messagesPosition: Observable<any>;
  rowAllPosition: MessagePosition[] = [];
  lstPosition: MessagePosition[] = [];
  public listComponentSubscribe = [];
  public tempPositions: any = {};
  private activeSubscriptions = 0;
  private subscribeComponent = [];

  constructor(
    private socketService: SocketService,
    private configService: ConfigService
  ) { }

  public createSubject() {
    const newService = {
      name: 'position',
      serviceSubject: this.serviceSubject
    };
    this.socketService.register(newService);
    this.messagesPosition = newService.serviceSubject.pipe(map(data => {
      const messageReturn: MessagePosition[] = [];
      if (data['listBeans'] && Array.isArray(data['listBeans'])) {
        data['listBeans'].forEach(element => {
          const msgPosition: MessagePosition = {
            type: 'position',
            account: element.account && element.account.value ? element.account.value : '0',
            market: element.marketID && element.marketID.value ? element.marketID.value : '0',
            marketCode: element.marketID && element.marketID.code ? element.marketID.code : '0',
            quote: element.quote && element.quote.value ? element.quote.value : '0',
            posMainRptID: element.posMainRptID && element.posMainRptID.value ? element.posMainRptID.value : '0',
            quoteType: element.quoteType && element.quoteType.value ? element.quoteType.value : '0',
            currentQuantity: element.currentQuantity && element.currentQuantity.value ? element.currentQuantity.value : '0',
            lastTrade: element.lastTrade && element.lastTrade.value ? element.lastTrade.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            previusTrade: element.previusTrade && element.previusTrade.value ? element.previusTrade.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            averagePrice: element.averagePrice && element.averagePrice.value ? element.averagePrice.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            initQuantity: element.initQuantity && element.initQuantity.value ? element.initQuantity.value : '0',
            quantityD1: element.quantityD1 && element.quantityD1.value ? element.quantityD1.value : '0',
            quantityD2: element.quantityD2 && element.quantityD2.value ? element.quantityD2.value : '0',
            quantityD3: element.quantityD3 && element.quantityD3.value ? element.quantityD3.value : '0',
            priceAverageInit: element.priceAverageInit && element.priceAverageInit.value ? element.priceAverageInit.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            valueCurrent: element.valueCurrent && element.valueCurrent.value ? element.valueCurrent.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            valueInit: element.valueInit && element.valueInit.value ? element.valueInit.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            valueSpent: element.valueSpent && element.valueSpent.value ? element.valueSpent.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            profitLoss: element.profitLoss && element.profitLoss.value ? element.profitLoss.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            profitLossPercent: element.profitLossPercent && element.profitLossPercent.value ? element.profitLossPercent.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            openBuy: element.openBuy && element.openBuy.value ? element.openBuy.value : '0',
            openSell: element.openSell && element.openSell.value ? element.openSell.value : '0',
            executedBuy: element.executedBuy && element.executedBuy.value ? element.executedBuy.value : '0',
            executedSell: element.executedSell && element.executedSell.value ? element.executedSell.value : '0',
            expired: element.expired && element.expired.value ? element.expired.value : '0',
            quantityBlocked: element.quantityBlocked && element.quantityBlocked.value ? element.quantityBlocked.value : '0',
            quantityReleased: element.quantityReleased && element.quantityReleased.value ? element.quantityReleased.value : '0',
            lastTradeDate: element.lastTradeDate && element.lastTradeDate.value ? element.lastTradeDate.value : '0',
            qtdTomadorBTC: element.qtdTomadorBTC && element.qtdTomadorBTC.value ? element.qtdTomadorBTC.value : '0',
            qtdDoadaBTC: element.qtdDoadaBTC && element.qtdDoadaBTC.value ? element.qtdDoadaBTC.value : '0',
            precoMedioTomadorBTC: element.precoMedioTomadorBTC && element.precoMedioTomadorBTC.value ? element.precoMedioTomadorBTC.value : '0',
            precoMedioDoadorBTC: element.precoMedioDoadorBTC && element.precoMedioDoadorBTC.value ? element.precoMedioDoadorBTC.value : '0',
            netDay: element.netDay && element.netDay.value ? element.netDay.value : '0',
            netPosition: element.netPosition && element.netPosition.value ? element.netPosition.value : '0',
            netDaytrade: element.netDaytrade && element.netDaytrade.value ? element.netDaytrade.value : '0',
            averagePricePos: element.averagePricePos && element.averagePricePos && element.averagePricePos.value ? element.averagePricePos.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            openProfitLoss: element.openProfitLoss && element.openProfitLoss.value ? element.openProfitLoss.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            closedProfitLoss: element.closedProfitLoss && element.closedProfitLoss.value ? element.closedProfitLoss.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            buyAvgPrice: element.buyAvgPrice && element.buyAvgPrice.value ? element.buyAvgPrice.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            sellAvgPrice: element.sellAvgPrice && element.sellAvgPrice.value ? element.sellAvgPrice.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            quotationForm: element.quotationForm && element.quotationForm.value ? element.quotationForm.value : '0',
            priorSetllPrice: element.priorSetllPrice && element.priorSetllPrice.value ? element.priorSetllPrice.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            securityType: element.SecurityType && element.SecurityType.value ? element.SecurityType.value : '0',
            totalPurchaseValue: element.totalPurchaseValue && element.totalPurchaseValue.value ? element.totalPurchaseValue.value : '0',
            totalSaleValue: element.totalSaleValue && element.totalSaleValue.value ? element.totalSaleValue.value : '0',
            executedDaytradePurchaseQty: element.executedDaytradePurchaseQty && element.executedDaytradePurchaseQty.value ? element.executedDaytradePurchaseQty.value : '0',
            executedDaytradeSaleQty: element.executedDaytradeSaleQty && element.executedDaytradeSaleQty.value ? element.executedDaytradeSaleQty.value : '0',
            notExecutedPurchaseDaytradeQty: element.notExecutedPurchaseDaytradeQty && element.notExecutedPurchaseDaytradeQty && element.notExecutedPurchaseDaytradeQty.value ? element.notExecutedPurchaseDaytradeQty.value : '0',
            notExecutedSaleDaytradeQty: element.notExecutedSaleDaytradeQty && element.notExecutedSaleDaytradeQty.value ? element.notExecutedSaleDaytradeQty.value : '0',
            avgValueDaytradeToday: element.avgValueDaytradeToday && element.avgValueDaytradeToday.value ? element.avgValueDaytradeToday.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            openProfitLossDaytrade: element.openProfitLossDaytrade && element.openProfitLossDaytrade.value ? element.openProfitLossDaytrade.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            valueAdjustedAmount: element.valueAdjustedAmount && element.valueAdjustedAmount.value ? element.valueAdjustedAmount.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            openAvgValueDaytradeToday: element.openAvgValueDaytradeToday && element.openAvgValueDaytradeToday.value ? element.openAvgValueDaytradeToday.value.replace('R$ ', '').replace('Pts. ', '') : '0',
            closedProfitLossDaytrade: element.closedProfitLossDaytrade && element.closedProfitLossDaytrade.value ? element.closedProfitLossDaytrade.value.replace('R$ ', '').replace('Pts. ', '') : '0',
          };
          messageReturn.push(msgPosition);
        });
      }
      this.updateTempPositions(messageReturn);
      return messageReturn;
    }));
  }

  updateTempPositions(positionsArray) {
    if (positionsArray.length > 0) {
      if (Object.keys(this.tempPositions).length == 0) {
        this.tempPositions[positionsArray[0].marketCode] = positionsArray;
      } else {
        if (this.tempPositions[positionsArray[0].marketCode]) {
          positionsArray.forEach(position => {
            const positionToEdit = this.tempPositions[positionsArray[0].marketCode].findIndex(item => item.quote == position.quote);
            if (positionToEdit != undefined && positionToEdit != -1) {
              this.tempPositions[positionsArray[0].marketCode][positionToEdit] = position;
            } else {
              this.tempPositions[positionsArray[0].marketCode].push(position);
            }
          });
        } else {
          this.tempPositions[positionsArray[0].marketCode] = positionsArray;
        }
      }
    }
  }

  public unsubscribePosition(account: string, componentName: string, forceUnsubscribe?: boolean) {
    const existSubscribe = this.subscribeComponent.findIndex(x => x === componentName);
    if (existSubscribe !== -1) {
      this.subscribeComponent.splice(existSubscribe, 1);
      this.activeSubscriptions--;
    }
    if (this.activeSubscriptions <= 0 || forceUnsubscribe) {
      if (forceUnsubscribe) {
        this.activeSubscriptions = 0;
      }
      this.tempPositions = [];
      this.sendMessagePosition(account, Constants.MARKET_BOVESPA, false);
      this.sendMessagePosition(account, Constants.MARKET_BMF, false);
      this.configService.writeLog('UNSUBSCRIBE POSITION > [' + this.listComponentSubscribe.length + '][' + account + '][BMF / BOVESPA][' + componentName.toUpperCase() + '] <<<<<');
    }
  }

  public subscribePosition(account: string, componentName: string) {
    if (this.activeSubscriptions <= 0) {
      this.sendMessagePosition(account, Constants.MARKET_BOVESPA, true);
      this.sendMessagePosition(account, Constants.MARKET_BMF, true);
      this.configService.writeLog('SUBSCRIBE POSITION > [' + this.listComponentSubscribe.length + '][' + account + '][BMF / BOVESPA][' + componentName.toUpperCase() + '] <<<<<');
    }
    const existSubscribe = this.subscribeComponent.find(x => x === componentName);
    if (!existSubscribe) {
      this.subscribeComponent.push(componentName);
      this.activeSubscriptions++;
    }
    return of(this.tempPositions);
  }

  private sendMessagePosition(account: string, market: string, dispatch: boolean) {
    const dataMsg: MessageWebFeeder = new MessageWebFeeder();
    dataMsg.token = this.configService.getToken();
    dataMsg.module = 'negotiation';
    dataMsg.service = 'position';
    const messageParameter = new MessageParameterNegotiation();
    messageParameter.account = account;
    messageParameter.market = market;
    messageParameter.dispatch = dispatch;
    messageParameter.history = true;
    dataMsg.parameters = messageParameter;
    if (market !== undefined) {
      setTimeout(() => {
        this.socketService.signService(dataMsg);
      }, 1000);
    }
  }

}
